import React, { useEffect } from 'react';
import SecondaryNav from 'components/mweb/SecondaryNav/SecondaryNav';
import { queryStringToJSON } from 'hb-redux-store/util/miscellaneousServices';
import AnalyticsService from 'AnalyticsService';
import WhatsappHelp from '../../common/WhatsappHelp/WhatsappHelp';

const PrivacyPolicy = props => {
  const email = 'care@vegxl.in';
  // const qs = queryStringToJSON(props.location.search);
  // const { header = true } = qs;

  useEffect(() => {
    // Clevertap Analytics
    const key = 'View Privacy Policy';
    const payload = {
      title: 'Privacy Policy',
    };
    AnalyticsService.clevertap.sendCleverTapEvent(key, payload);
  }, []);

  return (
    <div className="desktop-policy">
      {/* {header && (
        <SecondaryNav
          source="accounts"
          showCart={false}
          showSearch={false}
          title="Privacy Policy"
          capitalize
        />
      )} */}
      <div className="desktop-policy--header">Privacy Policy</div>
      <div className="bold">
        We are committed to protecting your privacy and your personal
        information
      </div>
      <p>
        By ordering from vegxl.in, you are accepting the practices described in
        this privacy policy. As we continue to develop our website and employ
        emerging technologies to improve the services we provide, this policy
        may change. We encourage you to refer to this policy to understand our
        current privacy policy. This policy covers the personal information that
        collects, uses or discloses and set out the way in which vegxl.in will
        use, manage and protect your personal information when you use the
        vegxl.in website or any other site, services, software, applications or
        media managed by vegxl.in. This policy may be revised from time to time.
        It is recommended that you carefully read this policy each time you
        visit the website. We at vegxl.in guarantee our commitment to respecting
        and protecting your online privacy.
      </p>
      <p>
        <span className="bold">Collection of information: </span>Every time you
        log on to our website your IP (Internet Protocol) address registers on
        our servers. Your IP address reveals no information other than the
        number assigned to you. We do not use this technology to get any
        personal data against your knowledge or free will (i.e., automatically
        recording e-mail addresses of visitors). Nor do we use it for any
        purpose other than to help us monitor traffic on our website, or (in
        case of criminal activity or misuse of our information) to cooperate
        with law enforcement.
      </p>
      <p>
        <span className="bold">Cookies: </span>When someone visits www.vegxl.in
        we log information and details of visitor behaviour patterns. We use
        Google Analytics (_utma, _utmb, _utmc, _utmz) These cookies are used to
        collect information about how visitors use our site. We use the
        information to compile reports and to help us improve the site. The
        cookies collect information in an anonymous form, including the number
        of visitors to the site, where visitors have come to the site from and
        the pages they visited.
      </p>
      <p>
        <span className="bold">Changes: </span>We may change this privacy
        policy, or change, modify or withdraw access to this Site, or the
        content of these pages at any time with or without notice.
      </p>
      <p>
        <span className="bold">Cancellation Policy: </span>We have a very
        liberal cancellation policy. Cancellation can happen at any time of the
        ordered placed. In case of quality deliverance failure; there will be
        refund or replacement 100%. But it should bring to our notice within 24
        hour of delivery. While every effort is made to ensure that accurate
        pricing and descriptions are maintained, we reserve the right to cancel
        any order that is based on inaccurate information. We will endeavour to
        notify you immediately of any such cancellation.
      </p>
      <p>
        <span className="bold">Refund Policy: </span>We have a "no questions
        asked return policy". All our customers can return the product at the
        time of delivery if they are not satisfied with the quality or freshness
        of the product. Once the refund is approved it may take 2 working days
        to initiate the refund request and you will receive a refund
        confirmation message/mail within that period. Please note in refund
        cases, the concerned bank may take 3-4 working days to post a credit to
        your account. For all online transactions, the refund will be processed
        immediately and will reflect in the customer's bank account. You can
        write us at {email}.
      </p>
      <WhatsappHelp />
    </div>
  );
};

export default PrivacyPolicy;
